<!-- eslint-disable max-lines -->
<template>
    <div>
        <div v-if="isDetail">
            <el-button @click="back">返 回</el-button>
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="运输单信息" name="info">
                    <el-table :data="infoData" border style="width: 100%">
                        <el-table-column v-for="item in infoTableColumn" :key="item.prop" :prop="item.prop"
                            :label="item.label" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="历史跟踪记录" name="record">
                    <el-button type="primary" @click="recordAdd" v-has="'05040101'">新 增</el-button>
                    <el-button type="primary" @click="abnormaAdd" v-has="'05040102'">新增异常信息</el-button>
                    <el-table :data="recordData" border style="width: 100%"
                        @selection-change="handleSelectionRecordChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column v-for="item in recordTableColumn" :key="item.prop"
                            :prop="item.prop" :label="item.label" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="异常信息" name="abnormal">
                    <el-button type="primary" @click="abnormaDel" v-has="'05040103'">删 除</el-button>
                    <el-table :data="abnormalData" border style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column v-for="item in abnormalTableColumn" :key="item.prop"
                            :prop="item.prop" :label="item.label" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <m-pane
            ref="tablePage"
            v-else
            class="tablePage"
            :config="config"
            :initSearchInfo="initSearchInfo"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @arrive-btn="arriveBtn"
            @searchChange="searchChange"
            @row-db-click="rowDBclick"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="ET_DISPATCH_ORDER_GRID_QUERY">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05020002'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
        <el-dialog
            title="到达"
            :visible.sync="visible"
            width="40%"
            @close="handleClose">
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="站点" prop="etdsNo">
                            <el-select v-model="ruleForm.etdsNo" placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in options" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="ruleForm.etdoRemark" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleClose()}">取 消</el-button>
                <el-button type="primary" @click="handleChange" :loading="saveLoading">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="新增"
            :visible.sync="recordAddVisible"
            width="40%"
            @close="handleRecordClose">
            <el-form
                ref="recordForm"
                inline
                :model="ruleRecordForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="是否异常">
                            <el-select v-model="ruleRecordForm.etisIsAbnormal" placeholder="请选择">
                                <el-option key='0' label="否" value="0"></el-option>
                                <el-option key='1' label="是" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="ruleRecordForm.etisRemark" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="跟踪省市" prop="adder">
                            <otp-all-address-select v-model="ruleRecordForm.adder" @getAddress='getAddress'
                                :minLayers='2' :basicProps='{}'>
                            </otp-all-address-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地点">
                            <el-input v-model="ruleRecordForm.etisLocationdetail" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleRecordClose()}">取 消</el-button>
                <el-button type="primary" @click="handleRecordChange" :loading="recordLoading">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="新增"
            :visible.sync="abnormalAddVisible"
            width="40%"
            @close="handleAbnormalClose">
            <el-form
                ref="abnormalForm"
                inline
                :model="ruleAbnormalForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="异常分类">
                            <otpSelect
                                style="width: 180px"
                                :optionNum="'SYS_TMS_ABNORMAL_TYPE'"
                                @getSelectValue="getSelectValue"
                                :mValue="ruleAbnormalForm.ettgAbnormalClass"
                                :prop="'ettgAbnormalClass'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="异常类型">
                            <el-select v-model="ruleAbnormalForm.ettgAbnormalType" placeholder="请选择">
                                <el-option
                                    v-for="item in abnormalOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="跟踪地点名称">
                            <el-input v-model="ruleAbnormalForm.ettgEtisLocation" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="ruleAbnormalForm.ettgRemark" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleAbnormalClose()}">取 消</el-button>
                <el-button type="primary" @click="handleAbnormalChange" :loading="abnormalLoading">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 电子围栏校验提示和备注 -->
        <dispatch-handle-reason
            v-if="isShowHandleReasonDialog"
            ref="dispatchHandleReason"
            :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
            :componentsData="componentsData"
            :handleType="handleType"
            @handleSuccess="_updateEttaStatus"
            @closeFenceDialog="closeFenceDialog"
        ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import otpAllAddressSelect from '@/components/lots/otpCascader2';
import otpSelect from '@/components/lots/otpSelect';
import reportExport from '@/components/lots/reportExportPlugin';
import { maxDay } from '@/modules/transport/tms/common/common';
import {
    getTranckingList,
    locate,
    getStopsList,
    updateEttaStatus,
    getOrderDetailsByEtdoNo,
    saveRansitHislItems,
    removeTransitTrackingByPk,
    getDictionaryDetailByCode,
    saveTransitTrackingItem
} from '../../../api/passage';
import { arriveCheckOperateReason } from '../../../api/dispatchOrder';
import DispatchHandleReason from '../../dispatchOrder/components/dispatchHandleReason/Index';
import { ConstantsDS } from '../../../constans/constans';
import dayjs from 'dayjs';
import common from '../../../common/common';
import { mapGetters } from 'vuex';
import mixin from './mixins.js';
const { getSessionKey, initSessionData } = common;
// const etisTracer = '捷辉物流'; // 定位的，暂时不写
const isArrive = true;
const isDischarge = false;
const etisTrackingWay = '00';
export default {
    mixins: [mixin],
    components: { mPane, otpAllAddressSelect, otpSelect, reportExport, DispatchHandleReason },
    data() {
        return {
            exportParams: {},
            isFirstSearch: true,
            saveLoading: false,
            componentsData: {},
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'arrival' // 操作类型：抵达
        };
    },
    mounted() {
        initSessionData(['SYS_MY_TMS_PROCUREMENT_CHANNEL']);
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier', 'user', 'currentTenant'])
    },
    methods: {
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.exportParams = {
                ...this.searchData,
                etdoCarrierCode: this.supplier.supplierCode
            };
            this.loading = true;
            const {
                SYS_TRANSPORT_DO_STATUS,
                SYS_MY_TMS_PROCUREMENT_CHANNEL,
                SYS_TMS_ZTB_FLAG
            } = sessionStorage;
            getTranckingList({
                pageNo,
                pageSize: this.pageSize,
                etdoCarrierCode: this.supplier.supplierCode,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 发车单状态
                        item.etdoStatusType = getSessionKey(item.etdoStatus, SYS_TRANSPORT_DO_STATUS);
                        // 采购渠道
                        item.etdoProcurementChannelType = getSessionKey(item.etdoProcurementChannel, SYS_MY_TMS_PROCUREMENT_CHANNEL);
                        // 直通宝标识
                        item.etdoLtlFlagType = getSessionKey(item.etdoLtlFlag, SYS_TMS_ZTB_FLAG);
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        _locate(data) {
            locate(data).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && !res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success(res.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.data.messagesAsString);
                }
            });
        },
        // 回显到达弹窗的站点
        _getStopsList(data) {
            getStopsList(data).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.options = res.data.data.map(item => {
                            return {
                                label: item.etdsName,
                                value: item.etdsNo
                            };
                        });
                    } else {
                        this.$message.error(res.data.detail); // 后端反馈messagesAsString 不知道为啥错误信息放不进去
                    }
                }
            });
        },
        // 关闭围栏备注弹窗
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
        },
        // 电子围栏校验，接口返回true则不需要备注人工操作原因，false则需要填写
        arrivalValidateFence (data) {
            const params = {
                dispatchNo: data.etdoNo,
                type: 'arrival',
                etdsNo: data.etdsNo // 站点序号，"type":"arrive"固定传"0"，"type":"arrival"传实际站点序号
            };
            return arriveCheckOperateReason(params).then(res => {
                if (res && +res.code === 0) {
                    return res.data.success;
                }
            }).catch(() => {
                return true;
            });
        },
        /**
         * description 手动抵达前 进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        _updateEttaStatus(isFenceRemarked = false) {
            this.$refs.form.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    // 电子围栏校验
                    if (!isFenceRemarked) {
                        // 校验是否需要提示和备注原因
                        const isNeedTooltip = await this.arrivalValidateFence(this.ruleForm);
                        if (!isNeedTooltip) {
                            this.isShowHandleReasonDialog = true;
                            this.handleType = 'arrival';
                            this.componentsData = this.ruleForm;
                            return;
                        }
                    }
                    // 继续到达操作
                    this.saveLoading = true;
                    const { etdoNo, etdsNo, etdoRemark } = this.ruleForm;
                    updateEttaStatus({
                        ettgEtdoNo: etdoNo,
                        etdsNo,
                        etdoRemark,
                        modifier: this.user.userName,
                        modifyTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm'),
                        etdsArriveTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm')
                    }).then(res => {
                        if (res) {
                            if (res.data.success) {
                                this.$message.success('保存成功!');
                                this.handleClose(true);
                            } else {
                                this.$message.error(res.data.messagesAsString);
                            }
                        } else {
                            this.$message.error(res.errMsg);
                        }
                    }).finally(() => {
                        this.saveLoading = false;
                    });
                }
            });
        },
        // 双击查看详情
        _getOrderDetailsByEtdoNo(etdoNo) {
            getOrderDetailsByEtdoNo({ etdoNo }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.infoData = res.data.data.etTaskMaterielQueryItemBean;
                        this.recordData = res.data.data.etTransitTrackingHisItemBean;
                        this.abnormalData = res.data.data.etTransitTrackingItemBean;
                    }
                } else {
                    this.$message.error(res.data.messagesAsString);
                }
            });
        },
        // 历史跟踪记录-新增
        _saveRansitHislItems() {
            this.$refs.recordForm.validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    const {
                        etisIsAbnormal,
                        etisRemark,
                        etisLocationdetail,
                        adder
                    } = this.ruleRecordForm;
                    this.recordLoading = true;
                    saveRansitHislItems({
                        etisEtdoNo: this.etdoNo,
                        etisTrackingWay,
                        etisTracer: this.user.userName,
                        etisDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                        etisIsAbnormal: etisIsAbnormal,
                        etisRemark: etisRemark,
                        etisLocationdetail: etisLocationdetail,
                        etisLocation: this.provinceNameCn + this.cityNameCn + etisLocationdetail,
                        provinceCode: adder[0],
                        cityCode: adder[1],
                        provinceNameCn: this.provinceNameCn,
                        cityNameCn: this.cityNameCn
                    }).then(res => {
                        if (res) {
                            if (res.data.success) {
                                this.$message.success('成功!');
                                this.handleRecordClose(true);
                            } else {
                                this.$message.error(res.data.messagesAsString);
                            }
                        } else {
                            this.$message.error(res.msg);
                        }
                        this.recordLoading = false;
                    });
                }
            });
        },
        // 新增异常信息
        _saveTransitTrackingItem() {
            const { ettgAbnormalClass, ettgAbnormalType, ettgEtisLocation, ettgRemark } = this.ruleAbnormalForm;
            this.abnormalLoading = true;
            saveTransitTrackingItem({
                ettgAbnormalClass,
                ettgAbnormalType,
                ettgEtisLocation,
                ettgRemark,
                ettgEtdoNo: this.etdoNo,
                ettgRegistrant: this.user.userName
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('成功!');
                        this.handleAbnormalClose();
                    }
                } else {
                    this.$message.error(res.msg);
                }
                this.abnormalLoading = false;
            });
        },
        _removeTransitTrackingByPk(ids) {
            removeTransitTrackingByPk(ids).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('成功!');
                        this._getOrderDetailsByEtdoNo(this.etdoNo);
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            if (!val.etdoStatus) { // 来自未前后端分离时后端的扯淡需求，当etdoStatus未选时，传递etdoStatuss=30,40,50,60,70,80
                val.etdoStatuss = '30,40,50,60,70,80';
            }
            this.searchData = val;
            this._getList();
        },
        arriveBtn(row) {
            if (row.etdoStatus !== ConstantsDS.DO_STATUS_ON_ORDER) {
                this.$message.error('不是在途状态');
                return false;
            }
            this.ruleForm.etdoNo = row.etdoNo;
            this._getStopsList({
                etdoNo: row.etdoNo,
                isArrive,
                isDischarge
            });
            this.visible = true;
        },
        handleClose(req) {
            this.ruleForm = {
                etdsNo: '',
                etdoRemark: '',
                etdoNo: ''
            };
            this.$refs.form.resetFields();
            this.visible = false;
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleChange() {
            this._updateEttaStatus();
        },
        rowDBclick(row) {
            this.etdoNo = row.etdoNo;
            this._getOrderDetailsByEtdoNo(row.etdoNo);
            this.isDetail = true;
        },
        back() {
            this.isDetail = false;
            this._getList();
        },
        recordAdd() {
            this.recordAddVisible = true;
        },
        getAddress(data) {
            if (data.length) {
                this.provinceNameCn = data[0];
                this.cityNameCn = data[1];
            }
        },
        handleRecordChange() {
            this._saveRansitHislItems();
        },
        handleRecordClose() {
            this.ruleRecordForm = {
                etisIsAbnormal: '',
                etisRemark: '',
                adder: '',
                etisLocationdetail: ''
            };
            this.$refs.recordForm.resetFields();
            this.recordAddVisible = false;
            this._getOrderDetailsByEtdoNo(this.etdoNo);
        },
        abnormaAdd() {
            if (!this.recordSelection.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            if (this.recordSelection.length > 1) {
                this.$message.error('只能选中一条数据');
                return false;
            }
            this.ruleAbnormalForm.ettgEtisLocation = this.recordSelection[0].etisLocation;
            this.abnormalAddVisible = true;
        },
        abnormaDel() {
            if (!this.abnormalSelection.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            this._removeTransitTrackingByPk(this.abnormalSelection.map(item => item.ettgId));
        },
        getSelectValue(val) {
            this.ruleAbnormalForm.ettgAbnormalClass = val.ettgAbnormalClass;
            if (val.ettgAbnormalClass === '00') {
                this._getDictionaryDetailByCode('SYS_TMS_TRACKING_TRANSIT');
            } else if (val.ettgAbnormalClass === '10') {
                this._getDictionaryDetailByCode('SYS_TMS_TRACKING_LOAD_UNLOAD');
            } else if (val.ettgAbnormalClass === '20') {
                this._getDictionaryDetailByCode('SYS_TMS_TRACKING_SUPPLIER');
            } else if (val.ettgAbnormalClass === '') {
                this.abnormalOptions = [];
                return false;
            } else {
                this._getDictionaryDetailByCode('SYS_TMS_TRACKING_OTHER');
            }
        },
        handleAbnormalClose() {
            this.ruleAbnormalForm = {
                ettgAbnormalClass: '',
                ettgAbnormalType: '',
                ettgEtisLocation: '',
                ettgRemark: ''
            };
            this.$refs.abnormalForm.resetFields();
            this.abnormalAddVisible = false;
            this._getOrderDetailsByEtdoNo(this.etdoNo);
        },
        handleAbnormalChange() {
            this._saveTransitTrackingItem();
        },
        _getDictionaryDetailByCode(key) {
            getDictionaryDetailByCode({ dictCodes: key }).then(res => {
                if (res && +res.code === 0) {
                    const arr = res.data[key];
                    this.abnormalOptions = [];
                    for (const item in arr) {
                        if (item && arr[item]) {
                            this.abnormalOptions.push({
                                label: arr[item],
                                value: item
                            });
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>
